export const columnsBillOkData = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "ORDER DATE",
    accessor: "order_date",
  },
  {
    Header: "EI TA",
    accessor: "ei_ta",
  },
  {
    Header: "BILL ID",
    accessor: "id_bill",
  },
  {
    Header: "SEQ",
    accessor: "seq",
  },
  {
    Header: "CUSTOMER TYPE",
    accessor: "customer_type",
  },
  {
    Header: "PAYMENT METHOD",
    accessor: "payment_method",
  },
  {
    Header: "POS ID",
    accessor: "pos_id",
  },
  {
    Header: "BRANCH ID",
    accessor: "branch_id",
  },
  {
    Header: "BRANCH NAME",
    accessor: "branch_name",
  },
  {
    Header: "PAKET ADDON",
    accessor: "paket_addon",
  },
  {
    Header: "PARENT ID",
    accessor: "parent_id",
  },
  {
    Header: "ERP ID",
    accessor: "erp_id",
  },
  {
    Header: "DESCRIPTION",
    accessor: "line_description",
  },
  {
    Header: "QTY",
    accessor: "quantity",
  },
  {
    Header: "UNIT PRICE",
    accessor: "unit_price",
  },
  {
    Header: "EXT PRICE",
    accessor: "ext_price",
  },
  {
    Header: "DISCOUNT PERCENT",
    accessor: "discount_percent",
  },
  {
    Header: "TOTAL DISCOUNT",
    accessor: "total_discount",
  },
  {
    Header: "AMOUNT",
    accessor: "amount",
  },
  {
    Header: "ID ITEM POS",
    accessor: "id_item_pos",
  },
  {
    Header: "PB1",
    accessor: "pb1",
  },
  {
    Header: "TAX AMOUNT",
    accessor: "tax_amount",
  },
  {
    Header: "NOTES PRODUCT",
    accessor: "notes_product",
  },
  {
    Header: "CATEGORY",
    accessor: "category",
  },
  {
    Header: "SUB CATEGORY",
    accessor: "sub_category",
  },
  {
    Header: "ORDER BEGIN",
    accessor: "order_begin",
  },
  {
    Header: "ORDER END",
    accessor: "order_end",
  },
  {
    Header: "NIK CASHIER",
    accessor: "nik_cashier",
  },
  {
    Header: "NAMA CASHIER",
    accessor: "nama_cashier",
  },
  {
    Header: "MEMBER CARD NO",
    accessor: "member_card_no",
  },
  {
    Header: "STATUS ITEM",
    accessor: "status_item",
  },
  {
    Header: "CANCEL REASON ITEM",
    accessor: "cancel_reason_item",
  },
  {
    Header: "BILL STATUS",
    accessor: "bill_status",
  },
  {
    Header: "CANCEL REASON ORDER",
    accessor: "cancel_reason_order",
  },
  {
    Header: "SHIFT",
    accessor: "shift",
  },
  {
    Header: "START TIME",
    accessor: "start_time",
  },
  {
    Header: "DATE CREATED",
    accessor: "date_created",
  },
  {
    Header: "POS VERSION",
    accessor: "pos_version",
  },
  {
    Header: "PAYMENT AMOUNT",
    accessor: "payment_amount",
  },
  {
    Header: "PAYMENT USED",
    accessor: "payment_used",
  },
  {
    Header: "PAYMENT REF",
    accessor: "payment_ref",
  },
  {
    Header: "APPROVAL CODE",
    accessor: "approval_code",
  },
  {
    Header: "TRANSACTION DATE",
    accessor: "transaction_date",
  },
  {
    Header: "TRANSACTION TIME",
    accessor: "transaction_time",
  },
  {
    Header: "MERCHANT ID",
    accessor: "merchant_id",
  },
  {
    Header: "TERMINAL ID",
    accessor: "terminal_id",
  },
  {
    Header: "CUSTOMER TYPE REFF ID",
    accessor: "customer_type_reff_id",
  },
];
